import { useCallback, useEffect, useId } from 'react';

/**
 * Пропсы хука useOpenSidePanelController
 */
interface UseOpenSidePanelControllerProps {
    /**
     * Уведомляет о том, что открывается другая шторка
     */
    onOtherInstanceOpening: () => void;
}

/**
 * Возвращаемое значение хука useOpenSidePanelController
 */
interface UseOpenSidePanelControllerReturn {
    /**
     * Колбэк для уведомления других шторок о своем открытии
     */
    notifyOpening: () => void;
}

/**
 * Подписчики на события открытия шторок
 */
const subscribers = new Map<string, UseOpenSidePanelControllerProps>();

/**
 * Хук для уведомления об открытии шторок и возможности их открытия
 * @param onOtherInstanceOpening Колбэк вызываемый когда другая шторка открывается
 * @returns Колбэк для уведомления об открытии
 */
export function useOpenSidePanelController({
    onOtherInstanceOpening,
}: UseOpenSidePanelControllerProps): UseOpenSidePanelControllerReturn {
    const id = useId();
    const notifyOpening = useCallback(() => {
        subscribers.forEach(({ onOtherInstanceOpening }, subscriberId) => {
            if (subscriberId !== id) {
                onOtherInstanceOpening();
            }
        });
    }, [id]);

    useEffect(() => {
        subscribers.set(id, { onOtherInstanceOpening });

        return () => {
            subscribers.delete(id);
        };
    }, [id, onOtherInstanceOpening]);

    return { notifyOpening };
}
